import React from 'react';
import { Link } from '@fiverr-private/typography';
import pathfinder from '@fiverr-private/pathfinder';

const SUPPORT_URL = 'https://help-pro.fiverr.com/hc/en-us/articles/30145706098065-Background-checks-legal-documents';
const LEGAL_TERMS_URL = 'https://www.fiverr.com/legal-portal/legal-terms/specialconditions';
const SUBSCRIPTION_PAGE_URL = pathfinder('subscription_plans_page');

export interface LinkProps {
    text: string;
}

const linkHOC =
    (url: string) =>
    // eslint-disable-next-line react/display-name
    ({ text }: LinkProps) =>
        (
            <Link href={url} target="_blank" color="inherit">
                {text}
            </Link>
        );

export const SupportLink = linkHOC(SUPPORT_URL);
export const LegalTermsLink = linkHOC(LEGAL_TERMS_URL);
export const SubscriptionPageLink = linkHOC(SUBSCRIPTION_PAGE_URL);
